import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const useGetPlantillaFromTeam = ()=>{
        const location = useLocation()
    const teamId = location.pathname.split('/')?.[2]
    const [plantilla, setPlantilla] = useState([])
    const [team, setTeam] = useState('')


    useEffect(()=>{
        if(!teamId) return;
        const url = 'https://web-production-58ed.up.railway.app/api/dt/get/oneteam'
        axios.post(url,{
            equipo: teamId 
        }).then(res => {
            const teamInfo = res?.data?.equipo
            setTeam(teamInfo)
            const filterPlayer = teamInfo?.jugadores?.filter(jugador => jugador?.jugador !== null)
            setPlantilla(filterPlayer)
        }).catch(e=> console.log(e))

    },[teamId])


    return{
        plantilla,
        team
    }
}